import styled from 'styled-components';

export const Section = styled.div`
  & + & {
    margin-top: 20px;
    padding-top: 20px;
    border-top: 1px solid ${({ theme }) => theme.colors.surface.surfaceOutline};
  }
`;

export const SectionTitle = styled.h5`
  margin: 0 0 4px;
  font-size: 12px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.surface.onSurface};
`;

export const SectionHint = styled.p`
  margin: 0 0 15px;
  font-size: 11px;
  line-height: 1.45;
  color: ${({ theme }) => theme.colors.surface.onSurfaceVariant};
`;

// Mesmas métricas do .field-wrapper de FaturamentoForm.module.scss: flex,
// margin-bottom 5px e 15px entre colunas. A folga vertical maior é necessária
// porque aqui a mensagem de validação aparece abaixo do campo.
export const Row = styled.div`
  display: flex;
  margin-bottom: 5px;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

// flex-basis 0 com min-width 0 para as colunas encolherem de verdade: com
// `1fr`/`width:100%` os campos não descem abaixo do min-content do input e
// estouram a largura do modal.
export const Col = styled.div<{ $grow?: number }>`
  flex: ${({ $grow }) => $grow ?? 1} 1 0;
  min-width: 0;

  & + & {
    margin-left: 15px;
  }

  @media (max-width: 768px) {
    & + & {
      margin-left: 0;
      margin-top: 5px;
    }
  }
`;
